export enum InventoryApiTags {
  inventory = "inventory",
  discount = "discount",
  warehouse = "warehouse",
}
